export enum Gateway {
  Workshop1 = 1,
  Workshop2 = 2,
  FollowUp = 3,
}